<dap-lib-popup
  *ngIf="showBackendErrorPopup$ | async as showBackendErrorPopup"
  [isOpen]="showBackendErrorPopup"
  [variant]="'red'"
  [title]="'GLOBAL.ERROR.TITLE' | translate"
  (cancel)="closePopup()"
  data-cy="backend-error-popup"
>
  <ng-container ngProjectAs="content">
    <div class="error-container">
      <dap-lib-icon
        *dapLibHideForBreakpoint="'for-XSmall-Down'"
        iconColor="red"
        iconSize="64"
        name="warning"
      ></dap-lib-icon>
      {{ 'GLOBAL.ERROR.BACKEND.MESSAGE' | translate }}
      <dap-lib-icon
        *dapLibShowForBreakpoint="'for-XSmall-Down'"
        iconColor="red"
        iconSize="48"
        name="warning"
      ></dap-lib-icon>
    </div>
  </ng-container>
</dap-lib-popup>
